import { Button, Divider, Skeleton, Typography } from "@mui/material";
import { Box } from "@mui/material";
import theme from "lib/theme";

export default function OrderSummaryLoadingComponent({ continueLabel }: { continueLabel: string }) {
  return (
    <div style={{ position: "sticky", top: "95px" }}>
      <Box
        sx={{
          py: 3,
          px: 4,
          background: "white",
          borderRadius: 1,
          border: `1px solid ${theme.palette.divider}`,
          [theme.breakpoints.down("lg")]: { px: 2, py: 2 },
        }}
      >
        <Typography fontWeight="bold" variant="h6">
          Order Summary
        </Typography>
        <Skeleton variant="text" sx={{ fontSize: "1rem", height: "2rem" }} />
        <Skeleton variant="text" sx={{ fontSize: "1rem", height: "2rem" }} />
        <Divider sx={{ my: 2 }} />
        <Skeleton variant="rectangular" height={80} sx={{ mb: 2 }} />
        <Button fullWidth variant="contained" disabled={true}>
          {continueLabel}
        </Button>
      </Box>
    </div>
  );
}
